<template>
  <div>
    <!-- 卡片-查询表单 -->
    <div class="md-layout card-form">
      <div class="md-layout-item md-layout md-size-30 md-xsmall-size-100" :style="{'padding':'0'}">
        <md-field>
          <label>UID</label>
          <md-input v-model="searchForm.uid"/>
        </md-field>
      </div>
      <div class="md-layout-item md-size-60 md-xsmall-size-100" :style="{'text-align':'left'}">
        <md-button class= "left-icon md-info" @click="form_changeSearchData">
          <md-icon>search</md-icon>
          {{$I18n("search")}}
        </md-button>
      </div>
    </div>
    <md-table v-model="tableData">
      <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="'ID'">{{ item.node_id }}</md-table-cell>
        <md-table-cell :md-label="$I18n('dev_snid')">{{ item.dev_id }}</md-table-cell>
        <md-table-cell :md-label="$I18n('dev_name')">{{ item.name }}</md-table-cell>
        <md-table-cell :md-label="$I18n('own_user')">{{ item.user_id }}</md-table-cell>
        <md-table-cell :md-label="$I18n('type')">{{ item.node_type_name }}</md-table-cell>

        <md-table-cell :md-label="$I18n('conn_type')">{{ item.node_type ?item.conn_mode_name :"" }}</md-table-cell>
        <md-table-cell :md-label="$I18n('vendor_id')">{{ item.vendor_id }}</md-table-cell>
        <md-table-cell :md-label="$I18n('dev_type')">{{ item.node_type ?item.dev_type_name :""}}</md-table-cell>
        <md-table-cell :md-label="'UID/IP'">{{ !item.conn_mode ?item.ip :item.uid }}</md-table-cell>
        <md-table-cell :md-label="$I18n('dev_user')">{{ item.dev_user }}</md-table-cell>
        <md-table-cell :md-label="$I18n('channel')">{{ item.ch_no }}</md-table-cell>
        <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
      </md-table-row>
      <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
    </md-table>
    <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
  </div>
</template>
<script>
import {timestampToString} from "@/common/tools.js";
export default {
  props: {
    ip:{
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchForm : {
        user_id:"",
        uid : "",
      },
      searchData : {
        user_id:"",
        uid : "",
      },

      tableInitData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  watch: { 
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage(){
      this.api_getPageData()
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            let node_type_name = this.$I18n("unknow");
            let conn_mode_name = this.$I18n("unknow");
            let dev_type_name = this.$I18n("unknow");

            if(item.node_type == 0 || !item.node_type){
              node_type_name = this.$I18n("catalogue")
            } else if(item.node_type == 1){
              node_type_name = this.$I18n("gateway_1")
            } else if(item.node_type == 2){
              node_type_name = this.$I18n("equipment")
            }

            if(item.conn_mode == 0 || !item.conn_mode){
              conn_mode_name = this.$I18n("id_conn")
            } else if(item.conn_mode == 1){
              conn_mode_name = this.$I18n("catalogue")
            } else if(item.conn_mode == 2){
              conn_mode_name = "P2P"
            }

            if(item.dev_type == 1){
              dev_type_name = this.$I18n("home_camera")
            } else if(item.dev_type == 2){
              dev_type_name = this.$I18n("cellular_equipemnt")
            } else if(item.dev_type == 3){
              dev_type_name = this.$I18n("hard_video")
            } else if(item.dev_type == 4){
              dev_type_name = this.$I18n("out_video")
            } else if(item.dev_type == 5){
              dev_type_name = this.$I18n("low_power")
            } else if(item.dev_type == 6){
              dev_type_name = this.$I18n("low_power_video")
            }
            return {
              ...item,
              node_type_name,
              conn_mode_name,
              dev_type_name,
              create_time: item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
            }
          })
      }
    },
  },
  methods: {
    // API-表格数据
    api_getPageData(){
      this.$api.getAppUserProductList({
        ...this.searchData,
        sip      : this.ip,
        page_size: this.pageSize,
        page_no  : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total  = res.count
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.searchData = {
        uid : this.searchForm.uid,
        user_id: this.searchForm.user_id,
      };
      if(this.searchData.uid){
        this.api_getPageData();
      } else {
        this.$errorMsg(this.$I18n("pls_input") + " UID")
      }
    },
  },
}
</script>